import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';

import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';

import { MatCheckboxModule } from '@angular/material/checkbox';

import { DcbmFormListFormAutoCompleteModule } from '../../chipList/DcbmFormList/DcbmFormList.module';

import { ParametreListFormComponent } from './ParametreList.component';

@NgModule({
  declarations: [ParametreListFormComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,

    MatInputModule,
    MatSelectModule,

    MatCheckboxModule,

    DcbmFormListFormAutoCompleteModule
  ],
  exports: [
    ParametreListFormComponent,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,

    MatInputModule,
    MatSelectModule,

    MatCheckboxModule,

    DcbmFormListFormAutoCompleteModule
  ]
})
export class ParametreListFormModule {}
